import {ZodTypeAny} from 'zod';
import {Skill, Tool} from '../copilot.types';

const universalTools: Tool<ZodTypeAny>[] = [];

function registerUniversalTools(tools: Tool<ZodTypeAny>[]): void {
  const existingNames = new Set(universalTools.map((tool) => tool.name));

  tools.forEach((tool) => {
    if (!existingNames.has(tool.name)) {
      universalTools.push(tool);
      existingNames.add(tool.name);
    }
  });
}

function getUniversalTools(): Tool<ZodTypeAny>[] {
  return universalTools;
}

function getToolsForSkills(skills: Skill[]): Tool<ZodTypeAny>[] {
  return [...universalTools, ...skills.flatMap((skill) => skill.tools)];
}

export {registerUniversalTools, getUniversalTools, getToolsForSkills};
